module.exports = __webpack_public_path__ + "media/images/orbit/pause-black-44b4319f555050a35c9ba2f8b6a549e176693421335a5ee64f9fd8bbef8dd5d5.png";